import { BaseSchedule } from "./BaseSchedule";
import { AllowedPrivacy } from "./Experience";
import { ScheduleOption } from "./ExperienceOption";

export interface Schedule extends BaseSchedule {
    allowedPrivacies: AllowedPrivacy[];
    departure?: ScheduleDeparture;
    priceDelta?: number;
    priceOverride?: boolean;
    options?: ScheduleOption[];
}

export enum ScheduleDeparture {
    FIXED = "fixed",
    VARIES = "varies",
}
